import _ from "lodash";
import produce from "immer";
import axios from "axios";
import strings from "../res/strings";
import { setAppProcessing, setAppSuccess, setAppError } from "../lib/common";

export const CREATE_PRODUCT = "productDevelopment/CREATE_PRODUCT";
export const UPDATE_PRODUCT = "productDevelopment/UPDATE_PRODUCT";
export const DELETE_PRODUCT = "productDevelopment/DELETE_PRODUCT";
export const RETRIEVE_PRODUCTS = "productDevelopment/RETRIEVE_PRODUCTS";

export const CREATE_PRODUCT_COMPONENT =
  "productDevelopment/CREATE_PRODUCT_COMPONENT";
export const UPDATE_PRODUCT_COMPONENT =
  "productDevelopment/UPDATE_PRODUCT_COMPONENT";
export const DELETE_PRODUCT_COMPONENT =
  "productDevelopment/DELETE_PRODUCT_COMPONENT";
export const RETRIEVE_PRODUCT_COMPONENTS =
  "productDevelopment/RETRIEVE_PRODUCT_COMPONENTS";

export const CREATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE =
  "productDevelopment/CREATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE";
export const UPDATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE =
  "productDevelopment/UPDATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE";
export const DELETE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE =
  "productDevelopment/DELETE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE";
export const SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE =
  "productDevelopment/SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE";
export const SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_LIST =
  "productDevelopment/SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_LIST";
export const CLEAR_ALL_SELECTED_CATALOGUE_ITEM_CHOICES =
  "productDevelopment/CLEAR_ALL_SELECTED_CATALOGUE_ITEM_CHOICES";

const CREATE_PRODUCT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const UPDATE_PRODUCT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const DELETE_PRODUCT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const RETRIEVE_PRODUCTS_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const CREATE_PRODUCT_COMPONENT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const UPDATE_PRODUCT_COMPONENT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const DELETE_PRODUCT_COMPONENT_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const RETRIEVE_PRODUCT_COMPONENTS_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const CREATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const UPDATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const DELETE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_LIST_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};
const CLEAR_ALL_SELECTED_CATALOGUE_ITEM_CHOICES_ERRORS = {
  DEFAULT: {
    message: strings.lib_common_state_error,
  },
};

const PRODUCT_DEVELOPMENT_PROJECT_CONTEXT = "prod_dev_proj";
const initialState = {
  // dictionary of dictionaries where the key is the group_id for the outer dictionary
  // and the product_id is the key for the inner dictionary returning a product/project dictionary
  products: {},

  // dictionary of dictionaries where the key is the project_id for the outer dictionary
  // and the component_id is the key for the 2nd inner dictionary returning the component object.
  productComponents: {},
};

export default (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CREATE_PRODUCT: {
        break;
      }

      case UPDATE_PRODUCT: {
        draft.products[action.groupId][action.groupProject.group_project_id] =
          action.groupProject;
        break;
      }

      case DELETE_PRODUCT: {
        break;
      }

      case RETRIEVE_PRODUCTS: {
        draft.products[action.groupId] = {};

        action.products.forEach((p) => {
          draft.products[action.groupId][p.group_project_id] = p;
        });
        break;
      }

      case CREATE_PRODUCT_COMPONENT: {
        break;
      }

      case UPDATE_PRODUCT_COMPONENT: {
        draft.productComponents[action.productId][action.productComponent.id] =
          action.productComponent;
        break;
      }

      case DELETE_PRODUCT_COMPONENT: {
        break;
      }

      case RETRIEVE_PRODUCT_COMPONENTS: {
        draft.productComponents[action.groupProjectId] = {};

        action.productComponents.forEach((pComponent) => {
          draft.productComponents[action.groupProjectId][
            pComponent.id
          ] = pComponent;
        });
        break;
      }

      case CREATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE: {
        break;
      }

      case UPDATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE: {
        break;
      }

      case DELETE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE: {
        break;
      }

      case SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE: {
        break;
      }

      default: {
        break;
      }
    }
  });

////////////// PROJECT ACTION CREATORS ////////////////
export const createProduct = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "product_development.createProduct",
          message: strings.lib_common_state_loading,
        }
      )
    );

    values.context = PRODUCT_DEVELOPMENT_PROJECT_CONTEXT;

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_COLLABORATION_CREATE_GROUP_PROJECT,
        values
      )
      .then((response) => {
        dispatch({ type: CREATE_PRODUCT });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "product_development.createProduct",
                },
            history
          )
        );
        dispatch(
          retrieveProducts({
            values,
            successState: {
              context: "product_development.createProduct.retrieveProducts",
            },
            errorState: (error) => ({
              ...error,
              context: "product_development.createProduct.retrieveProducts",
              notificationType: "alert",
            }),
          })
        );
      })
      .catch((errorResponse) => {
        let error = CREATE_PRODUCT_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "product_development.createProduct",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const updateProduct = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "product_development.updateProduct",
          message: strings.lib_common_state_loading,
        }
      )
    );

    values.context = PRODUCT_DEVELOPMENT_PROJECT_CONTEXT;

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_COLLABORATION_UPDATE_GROUP_PROJECT,
        values
      )
      .then((response) => {
        const groupProject = _.get(response, "data.group_project");
        const groupId = _.get(values, "group_id");

        dispatch({ type: UPDATE_PRODUCT, groupProject, groupId });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "product_development.updateProduct",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = UPDATE_PRODUCT_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "product_development.updateProduct",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const deleteProduct = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "product_development.deleteProduct",
          message: strings.lib_common_state_loading,
        }
      )
    );

    values.context = PRODUCT_DEVELOPMENT_PROJECT_CONTEXT;

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_COLLABORATION_DELETE_GROUP_PROJECT,
        values
      )
      .then((response) => {
        dispatch({ type: DELETE_PRODUCT });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "product_development.deleteProduct",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = DELETE_PRODUCT_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "product_development.deleteProduct",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const retrieveProducts = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "product_development.retrieveProducts",
          message: strings.lib_common_state_loading,
        }
      )
    );

    values.context = PRODUCT_DEVELOPMENT_PROJECT_CONTEXT;

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env.REACT_APP_API_LIB_COLLABORATION_RETRIEVE_GROUP_PROJECTS,
        values
      )
      .then((response) => {
        const products = _.get(response, "data.group_projects", []);
        const groupId = _.get(values, "group_id");

        dispatch({
          type: RETRIEVE_PRODUCTS,
          products,
          groupId,
        });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "product_development.retrieveProducts",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = RETRIEVE_PRODUCTS_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "product_development.retrieveProducts",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

////////////// PROJECT COMPONENTS ACTION CREATORS ////////////////
export const createProductComponent = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "product_development.createProductComponent",
          message: strings.lib_common_state_loading,
        }
      )
    );

    values.context = PRODUCT_DEVELOPMENT_PROJECT_CONTEXT;

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env
            .REACT_APP_API_PRODUCT_DEVELOPMENT_CREATE_PRODUCT_COMPONENT,
        values
      )
      .then((response) => {
        dispatch({ type: CREATE_PRODUCT_COMPONENT });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "product_development.createProductComponent",
                },
            history
          )
        );
        dispatch(
          retrieveProductComponents(
            {
              values,
              successState: {
                context:
                  "productDevelopment.createProductComponent.retrieveProductComponents",
              },
              errorState: (error) => ({
                context:
                  "productDevelopment.createProductComponent.retrieveProductComponents",
                notificationType: "alert",
                ...error,
              }),
            },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = CREATE_PRODUCT_COMPONENT_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "product_development.createProductComponent",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const updateProductComponent = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "product_development.updateProductComponent",
          message: strings.lib_common_state_loading,
        }
      )
    );

    values.context = PRODUCT_DEVELOPMENT_PROJECT_CONTEXT;

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env
            .REACT_APP_API_PRODUCT_DEVELOPMENT_UPDATE_PRODUCT_COMPONENT,
        values
      )
      .then((response) => {
        const productId = _.get(values, "group_project_id");
        const productComponent = _.get(response, "data.product_component");

        dispatch({
          type: UPDATE_PRODUCT_COMPONENT,
          productId,
          productComponent,
        });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "product_development.updateProductComponent",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = UPDATE_PRODUCT_COMPONENT_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "product_development.updateProductComponent",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const deleteProductComponent = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "product_development.deleteProductComponent",
          message: strings.lib_common_state_loading,
        }
      )
    );

    values.context = PRODUCT_DEVELOPMENT_PROJECT_CONTEXT;

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env
            .REACT_APP_API_PRODUCT_DEVELOPMENT_DELETE_PRODUCT_COMPONENT,
        values
      )
      .then((response) => {
        dispatch({ type: DELETE_PRODUCT_COMPONENT });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "product_development.deleteProductComponent",
                },
            history
          )
        );
        dispatch(
          retrieveProductComponents(
            {
              values,
              successState: {
                context:
                  "productDevelopment.deleteProductComponent.retrieveProductComponents",
              },
              errorState: (error) => ({
                context:
                  "productDevelopment.deleteProductComponent.retrieveProductComponents",
                notificationType: "alert",
                ...error,
              }),
            },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = DELETE_PRODUCT_COMPONENT_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "product_development.deleteProductComponent",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const retrieveProductComponents = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    setAppProcessing(
      processingState ?? {
        context: "product_development.retrieveProductComponents",
        message: strings.lib_common_state_loading,
      }
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env
            .REACT_APP_API_PRODUCT_DEVELOPMENT_RETRIEVE_PRODUCT_COMPONENTS,
        values
      )
      .then((response) => {
        const productComponents = _.get(
          response,
          "data.product_components",
          []
        );
        const groupId = _.get(values, "group_id");
        const groupProjectId = _.get(values, "group_project_id");

        dispatch({
          type: RETRIEVE_PRODUCT_COMPONENTS,
          productComponents,
          groupId,
          groupProjectId,
        });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context: "product_development.retrieveProductComponents",
                },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = RETRIEVE_PRODUCT_COMPONENTS_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context: "product_development.retrieveProductComponents",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

///////////// COMPONENT CATALOGUE ITEM CHOICE ACTION CREATORS /////////////
export const createProductComponentCatalogueItemChoice = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context:
            "product_development.createProductComponentCatalogueItemChoice",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env
            .REACT_APP_API_PRODUCT_DEVELOPMENT_CREATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE,
        values
      )
      .then((response) => {
        dispatch({ type: CREATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context:
                    "product_development.createProductComponentCatalogueItemChoice",
                },
            history
          )
        );
        dispatch(
          retrieveProductComponents(
            {
              values,
              successState: {
                context:
                  "productDevelopment.createProductComponentCatalogueItemChoice.retrieveProductComponents",
              },
              errorState: (error) => ({
                context:
                  "productDevelopment.createProductComponentCatalogueItemChoice.retrieveProductComponents",
                notificationType: "alert",
                ...error,
              }),
            },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error =
          CREATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context:
                    "product_development.createProductComponentCatalogueItemChoice",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const updateProductComponentCatalogueItemChoice = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context:
            "product_development.updateProductComponentCatalogueItemChoice",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env
            .REACT_APP_API_PRODUCT_DEVELOPMENT_UPDATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE,
        values
      )
      .then((response) => {
        dispatch({ type: UPDATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context:
                    "product_development.updateProductComponentCatalogueItemChoice",
                },
            history
          )
        );
        dispatch(
          retrieveProductComponents(
            {
              values,
              successState: {
                context:
                  "productDevelopment.updateProductComponentCatalogueItemChoice.retrieveProductComponents",
              },
              errorState: (error) => ({
                context:
                  "productDevelopment.updateProductComponentCatalogueItemChoice.retrieveProductComponents",
                notificationType: "alert",
                ...error,
              }),
            },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error =
          UPDATE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context:
                    "product_development.updateProductComponentCatalogueItemChoice",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const deleteProductComponentCatalogueItemChoice = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context:
            "product_development.deleteProductComponentCatalogueItemChoice",
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env
            .REACT_APP_API_PRODUCT_DEVELOPMENT_DELETE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE,
        values
      )
      .then((response) => {
        dispatch({ type: DELETE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context:
                    "product_development.deleteProductComponentCatalogueItemChoice",
                },
            history
          )
        );
        dispatch(
          retrieveProductComponents(
            {
              values,
              successState: {
                context:
                  "productDevelopment.deleteProductComponentCatalogueItemChoice.retrieveProductComponents",
              },
              errorState: (error) => ({
                context:
                  "productDevelopment.deleteProductComponentCatalogueItemChoice.retrieveProductComponents",
                notificationType: "alert",
                ...error,
              }),
            },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error =
          DELETE_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context:
                    "product_development.deleteProductComponentCatalogueItemChoice",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};

export const selectProductComponentCatalogueItemChoice = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context:
            "product_development.selectProductComponentCatalogueItemChoice",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env
            .REACT_APP_API_PRODUCT_DEVELOPMENT_SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE,
        values
      )
      .then((response) => {
        dispatch({ type: SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context:
                    "product_development.selectProductComponentCatalogueItemChoice",
                },
            history
          )
        );
        dispatch(
          retrieveProductComponents(
            {
              values,
              successState: {
                context:
                  "productDevelopment.selectProductComponentCatalogueItemChoice.retrieveProductComponents",
              },
              errorState: (error) => ({
                context:
                  "productDevelopment.selectProductComponentCatalogueItemChoice.retrieveProductComponents",
                notificationType: "alert",
                ...error,
              }),
            },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error =
          SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context:
                    "product_development.selectProductComponentCatalogueItemChoice",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};
export const selectProductComponentCatalogueItemChoiceList = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context:
            "product_development.selectProductComponentCatalogueItemChoiceList",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env
            .REACT_APP_API_PRODUCT_DEVELOPMENT_SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_LIST,
        values
      )
      .then((response) => {
        dispatch({ type: SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_LIST });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context:
                    "product_development.selectProductComponentCatalogueItemChoiceList",
                },
            history
          )
        );
        dispatch(
          retrieveProductComponents(
            {
              values,
              successState: {
                context:
                  "productDevelopment.selectProductComponentCatalogueItemChoiceList.retrieveProductComponents",
              },
              errorState: (error) => ({
                context:
                  "productDevelopment.selectProductComponentCatalogueItemChoiceList.retrieveProductComponents",
                notificationType: "alert",
                ...error,
              }),
            },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error =
          SELECT_PRODUCT_COMPONENT_CATALOGUE_ITEM_CHOICE_LIST_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  notificationType: "alert",
                  context:
                    "product_development.selectProductComponentCatalogueItemChoiceList",
                },
            history
          )
        );
      });
  };
};
export const clearAllSelectedCatalogueItemChoices = (
  { values, processingState, successState, errorState },
  history
) => {
  return (dispatch) => {
    dispatch(
      setAppProcessing(
        processingState ?? {
          context: "product_development.clearAllSelectedCatalogueItemChoices",
          message: strings.lib_common_state_loading,
        }
      )
    );

    axios
      .post(
        process.env.REACT_APP_API_SERVER_HOST +
          process.env
            .REACT_APP_API_PRODUCT_DEVELOPMENT_CLEAR_ALL_SELECTED_CATALOGUE_ITEM_CHOICES,
        values
      )
      .then((response) => {
        dispatch({ type: CLEAR_ALL_SELECTED_CATALOGUE_ITEM_CHOICES });
        dispatch(
          setAppSuccess(
            typeof successState === "function"
              ? successState(response, values)
              : successState ?? {
                  context:
                    "product_development.clearAllSelectedCatalogueItemChoices",
                },
            history
          )
        );
        dispatch(
          retrieveProductComponents(
            {
              values,
              successState: {
                context:
                  "productDevelopment.clearAllSelectedCatalogueItemChoices.retrieveProductComponents",
              },
              errorState: (error) => ({
                context:
                  "productDevelopment.clearAllSelectedCatalogueItemChoices.retrieveProductComponents",
                notificationType: "alert",
                ...error,
              }),
            },
            history
          )
        );
      })
      .catch((errorResponse) => {
        let error = CLEAR_ALL_SELECTED_CATALOGUE_ITEM_CHOICES_ERRORS.DEFAULT;

        dispatch(
          setAppError(
            typeof errorState === "function"
              ? errorState(error, values)
              : errorState ?? {
                  ...error,
                  context:
                    "product_development.clearAllSelectedCatalogueItemChoices",
                  notificationType: "alert",
                },
            history
          )
        );
      });
  };
};
